import { isRowAdBannerApiType } from './rowAdBannerTypes';
import { normalizeRowAdApiCategory } from './rowAdCategoryNormalize';
/** Sem imagem: Neutral/bg — tertiary (design system) */
const DEFAULT_SOLID_BACKGROUND = 'var(--neutral-bg-tertiary)';

function isRowAdBannerShape(item) {
  return item && typeof item === 'object' && isRowAdBannerApiType(item.type);
}

/**
 * @param {unknown} raw
 * @returns {object|null}
 */
function findRowAdsBannerPayload(raw) {
  if (!raw || typeof raw !== 'object') {
    return null;
  }
  if (isRowAdBannerShape(raw)) {
    return raw;
  }
  const keys = ['elements', 'data', 'items', 'banners', 'carousel', 'content'];
  for (const key of keys) {
    const arr = raw[key];
    if (Array.isArray(arr)) {
      const found = arr.find((x) => isRowAdBannerShape(x));
      if (found) {
        return found;
      }
    }
  }
  if (Array.isArray(raw)) {
    return raw.find((x) => isRowAdBannerShape(x)) || null;
  }
  return null;
}

/**
 * @param {unknown} raw
 * @param {{ elementId?: string }} [options]
 * @returns {object|null} Modelo para `RowAdLine` + `category`/`position` (filtro EPG)
 */
export function mapCommunicationCarouselToRowAd(raw, options = {}) {
  const item = findRowAdsBannerPayload(raw);
  if (!item) {
    return null;
  }

  const title = typeof item.title === 'string' ? item.title.trim() || null : null;

  const logoUrlRaw = item.logoUrl ?? item.logoURL;
  const logoUrlTrim = typeof logoUrlRaw === 'string' && logoUrlRaw.trim() ? logoUrlRaw.trim() : null;

  const backgroundUrlRaw = item.backgroundUrl ?? item.backgroundURL;
  const backgroundUrl = typeof backgroundUrlRaw === 'string' && backgroundUrlRaw.trim()
    ? backgroundUrlRaw.trim()
    : null;

  const backgroundColorRaw = typeof item.backgroundColor === 'string' && item.backgroundColor.trim()
    ? item.backgroundColor.trim()
    : null;

  const hasBgUrl = Boolean(backgroundUrl);
  const hasExplicitBgColor = Boolean(backgroundColorRaw);

  /** @type {string|null} */
  let backgroundImageUrl = null;
  /** @type {string|null} */
  let logoUrl = null;
  /** @type {string|null} */
  let backgroundColor = null;

  if (hasBgUrl) {
    backgroundImageUrl = backgroundUrl;
    logoUrl = logoUrlTrim || null;
    backgroundColor = null;
  } else if (hasExplicitBgColor && logoUrlTrim) {
    backgroundImageUrl = null;
    backgroundColor = backgroundColorRaw;
    logoUrl = logoUrlTrim;
  } else if (hasExplicitBgColor) {
    backgroundImageUrl = null;
    backgroundColor = backgroundColorRaw;
    logoUrl = null;
  } else {
    backgroundImageUrl = null;
    backgroundColor = DEFAULT_SOLID_BACKGROUND;
    logoUrl = logoUrlTrim || null;
  }

  const cta = item?.cta && typeof item?.cta === 'object' ? item?.cta : null;
  const linkRaw = cta && typeof cta?.link === 'string' ? cta?.link.trim() : '';
  const linkHref = linkRaw || null;

  const rawCategory = typeof item?.category === 'string' && item?.category.trim()
    ? item.category.trim()
    : '';
  const category = normalizeRowAdApiCategory(rawCategory)
    || (rawCategory ? rawCategory.toLowerCase() : '');

  const positionNum = Number(item.position);
  const position = Number.isFinite(positionNum) && positionNum >= 0 ? positionNum : 1;

  const idSource = (options?.elementId || '').trim() || 'carousel';

  if (!category) {
    return null;
  }

  return {
    id: `${idSource}-row-ad`,
    category,
    position,
    title,
    logoUrl,
    backgroundImageUrl,
    backgroundColor,
    linkHref,
    linkExternal: Boolean(linkHref && /^https?:\/\//i.test(linkHref)),
  };
}
